import { Outlet } from 'react-router-dom';
import { Page } from 'redesign';
import { PlanningProvider } from './providers/planning-actions-provider';
import { ShiftDetails } from './components/shift-details/shift-details';
import { PlanningParamsProvider } from './providers/planning-params-provider';
import { PlanningToolBox } from './toolbox/planning-toolbox';
import { PlanningRoutes } from './planning-routes';
import { PlanningSidebar } from './planning-sidebar';

export const Planning = () => {
  return (
    <PlanningParamsProvider>
      <PlanningProvider>
        <Page header={<PlanningToolBox />}>
          <PlanningRoutes />
          <Outlet />
          <ShiftDetails />
        </Page>
        <PlanningSidebar />
      </PlanningProvider>
    </PlanningParamsProvider>
  );
};
